import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { useAuth } from '../../AuthProvider/AuthProvider'
import { getFormattedDiningOption } from '../fulfillment-helpers'

import './FulfillmentHeader.css'

export const FulfillmentHeader = ({ editing, diningOptionBehavior }) => {
  const { user, authenticated } = useAuth()
  return (
    <React.Fragment>
      {authenticated &&
        !editing && (
        <p data-testid='scheduled-modal-welcome' styleName='welcome'>
            Welcome
          {user.firstName ? `, ${user.firstName}` : ''}!
        </p>
      )}
      {
        <h2 data-testid='scheduled-modal-header' styleName={cx('header', { editing })}>
          {editing && 'Edit '}
          Order for {getFormattedDiningOption(diningOptionBehavior)}
        </h2>
      }
    </React.Fragment>
  )
}

FulfillmentHeader.propTypes = {
  editing: PropTypes.bool,
  diningOptionBehavior: PropTypes.string
}
